import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { isLoggedIn, verifySession, hasAccess } from './services/auth';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Consumers from './pages/Consumers';
import ConsumerDetail from './pages/ConsumerDetail';
import ConsumerForm from './pages/ConsumerForm';
import Readings from './pages/Readings';
import BatchReading from './pages/BatchReading';
import Billing from './pages/Billing';
import GenerateBills from './pages/GenerateBills';
import Payments from './pages/Payments';
import Notices from './pages/Notices';
import Reports from './pages/Reports';
import Rates from './pages/Rates';
import Ledger from './pages/Ledger';

import Users from './pages/Users';
import Import from './pages/Import';

function ProtectedRoute({ path, children }) {
  if (!isLoggedIn()) return <Navigate to="/login" />;
  if (path && !hasAccess(path)) return <Navigate to="/" />;
  return children;
}

export default function App() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (isLoggedIn()) {
      verifySession().finally(() => setReady(true));
    } else {
      setReady(true);
    }
  }, []);

  if (!ready) return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>Loading...</div>;

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={isLoggedIn() ? <Navigate to="/" /> : <Login />} />
        <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/consumers" element={<Consumers />} />
          <Route path="/consumers/add" element={<ProtectedRoute path="/consumers"><ConsumerForm /></ProtectedRoute>} />
          <Route path="/consumers/:id" element={<ConsumerDetail />} />
          <Route path="/consumers/:id/edit" element={<ProtectedRoute path="/consumers"><ConsumerForm /></ProtectedRoute>} />
          <Route path="/readings" element={<Readings />} />
          <Route path="/readings/batch/:barangayId" element={<ProtectedRoute path="/readings"><BatchReading /></ProtectedRoute>} />
          <Route path="/billing" element={<ProtectedRoute path="/billing"><Billing /></ProtectedRoute>} />
          <Route path="/billing/generate" element={<ProtectedRoute path="/billing"><GenerateBills /></ProtectedRoute>} />
          <Route path="/payments" element={<ProtectedRoute path="/payments"><Payments /></ProtectedRoute>} />
          <Route path="/notices" element={<ProtectedRoute path="/notices"><Notices /></ProtectedRoute>} />
          <Route path="/reports" element={<ProtectedRoute path="/reports"><Reports /></ProtectedRoute>} />
          <Route path="/rates" element={<ProtectedRoute path="/rates"><Rates /></ProtectedRoute>} />
          <Route path="/ledger" element={<ProtectedRoute path="/ledger"><Ledger /></ProtectedRoute>} />
          <Route path="/users" element={<ProtectedRoute path="/users"><Users /></ProtectedRoute>} />
          <Route path="/import" element={<ProtectedRoute path="/import"><Import /></ProtectedRoute>} />
        </Route>
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}
